/* eslint-disable perfectionist/sort-objects */

import { defineTokens } from '@chakra-ui/react';

export const spacing = defineTokens({
	spacing: {
		'2xs': { value: '8px' },
		'xs':  { value: '16px' },
		'sm':  { value: '24px' },
		'md':  { value: '32px' },
		'lg':  { value: '48px' },
		'xl':  { value: '64px' },
		'2xl': { value: '80px' },
	},
});
